import { render, staticRenderFns } from "./aiDrawer.vue?vue&type=template&id=5f8e02b4&scoped=true"
import script from "./aiDrawer.vue?vue&type=script&lang=js"
export * from "./aiDrawer.vue?vue&type=script&lang=js"
import style0 from "./aiDrawer.vue?vue&type=style&index=0&id=5f8e02b4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f8e02b4",
  null
  
)

export default component.exports